import React, { useEffect, useState } from 'react';
import { Row, Col, Image, Tab, Nav, Button } from 'react-bootstrap';
import Star from '../../assets/images/star.svg';
import Bad from '../../assets/images/bad.png';
import Neutral from '../../assets/images/neutral.png';
import Excellent from '../../assets/images/excellent.png';
import './Feedback.css';
import EmptyRow from '../emptyRow/EmptyRow';
import Back from '../../assets/images/ic-arrow-back.svg';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { GetUserData, selectUserData } from '../../features/home/userSlice';
import { feedback } from '../../features/network/ApiCall';
import swal from 'sweetalert';

const Feedback = ({ pageName }: { pageName: any }) => {
  const [onHide, setOnhide] = useState(true);
  const [activeTab, setActiveTab] = useState(1);
  const [feedbackection, setfeedbackection] = useState(true);
  const [rating, setRating] = useState('');
  const [comment, setComment] = useState('');
  const userData = useAppSelector(selectUserData);
  const dispatch = useAppDispatch();
  const userDetails = localStorage.getItem('userDetails');
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  useEffect(() => {
    // async function fetchUser() {
    //   let sample = await dispatch(GetUserData(userDetailsJson));
    // }
    // fetchUser();
  }, []);
  const showFeedback = () => {
    setOnhide(false);
    dispatch(GetUserData(userDetailsJson));
  };
  const hideFeedback = () => {
    setOnhide(true);
    setfeedbackection(true);
    setRating('');
  };
  const goBackTab = () => {
    setfeedbackection(true);
  };
  const handleActive = (key: any) => {
    // alert( key);
    setActiveTab(key);
    setfeedbackection(false);
    setRating(key);
  };
  const handleSubmit = () => {
    var axios = require('axios');
    var data = {
      employeeId: userData?.employeeId,
      employeeName: userData?.name,
      page: pageName,
      rating: rating,
      comment: comment,
      sourceType: 'engportal'
    };

    var config = {
      method: 'post',
      url: feedback,
      headers: {
        Authorization: 'Basic d29ya1BvcnRhbDpwQHNzd29yZA==',
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios(config)
      .then(function (response: any) {
        // console.log(JSON.stringify(response.data));
        swal('Feedback Saved', 'success');
        setOnhide(true);
      })
      .catch(function (error: any) {
        // console.log(error);
        swal('Something went wrong!', 'error');
      });
  };
  return (
    <>
      {onHide !== false ? (
        <Row>
          <Col sm={12}>
            <div className='popup-btn desk'>
              <a href='#' onClick={showFeedback}>
                <Image src={Star} />
                <span style={{ marginLeft: '5px' }}>Feedback</span>
              </a>
            </div>

            <div className='popup-btnmob mob'>
              <a href='#' onClick={showFeedback}>
                <Image src={Star} style={{ width: '20%' }} />{' '}
              </a>
            </div>
          </Col>
        </Row>
      ) : null}

      {onHide !== true ? (
        <div className='card cardDiv'>
          <Row>
            <Col sm={12}>
              {feedbackection !== true ? (
                <span style={styles.backstyle} onClick={goBackTab}>
                  <Image src={Back} />
                  Back{' '}
                </span>
              ) : null}
              <span
                onClick={hideFeedback}
                style={{ float: 'right', cursor: 'pointer' }}
              >
                X
              </span>
            </Col>
          </Row>
          <div className='card-body'>
            <Tab.Container defaultActiveKey={activeTab} onSelect={handleActive}>
              <Row>
                <Col sm={12}>
                  <div>
                    {feedbackection !== false ? (
                      <div className='first'>
                        <p className='cardtitle'>
                          How has your experience been so far?
                        </p>
                        <EmptyRow />
                        <Row>
                          <Col sm={4} xs={4} className='text-center'>
                            <Image
                              src={Excellent}
                              onClick={() => handleActive('Excellent')}
                            />
                            <br />
                            <p className='emojip'>Excellent</p>{' '}
                          </Col>

                          <Col sm={4} xs={4} className='text-center'>
                            <Image
                              src={Neutral}
                              onClick={() => handleActive('Neutral')}
                            />{' '}
                            <br />
                            <p className='emojip'>Neutral</p>
                          </Col>
                          <Col sm={4} xs={4} className='text-center'>
                            <Image
                              src={Bad}
                              onClick={() => handleActive('Bad')}
                            />{' '}
                            <br />
                            <p className='emojip'>Bad</p>
                          </Col>
                        </Row>
                        <EmptyRow />
                        <EmptyRow />
                        <Row className='mx-auto pb-0'>
                          <Col sm={12} className='px-0'>
                            <Nav>
                              <Nav.Item>
                                <Nav.Link
                                  eventKey={1}
                                  active
                                  className='feedbacknavtabs'
                                ></Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link
                                  eventKey={2}
                                  className='feedbacknavtabs'
                                ></Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      <div className='second'>
                        <form>
                          {rating === 'Bad' ? (
                            <p className='cardtitle'>
                              We're sorry you're having a bad experience. What
                              can we do to improve?
                            </p>
                          ) : null}
                          {rating === 'Neutral' ? (
                            <p className='cardtitle'>
                              Got it! Is there something we can do to improve
                              your experience?
                            </p>
                          ) : null}
                          {rating === 'Excellent' ? (
                            <p className='cardtitle'>
                              Glad you like the experience. Tell us what you
                              love most?
                            </p>
                          ) : null}
                          <textarea
                            rows={5}
                            cols={45}
                            onChange={(
                              ev: React.ChangeEvent<HTMLTextAreaElement>
                            ): void => setComment(ev.target.value)}
                            placeholder='Share your feedback(optional)'
                          />
                          <EmptyRow />

                          <Button
                            style={styles.btn1}
                            variant='danger'
                            type='button'
                            onClick={handleSubmit}
                          >
                            SUBMIT
                          </Button>
                        </form>

                        <EmptyRow />
                        <EmptyRow />
                        <Row className='mx-auto pb-0'>
                          <Col sm={12} className='px-0'>
                            <Nav>
                              <Nav.Item>
                                <Nav.Link
                                  eventKey={1}
                                  active={false}
                                  className='feedbacknavtabs'
                                ></Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link
                                  eventKey={2}
                                  active
                                  className='feedbacknavtabs'
                                ></Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </div>
      ) : null}
    </>
  );
};

const styles: any = {
  backstyle: {
    color: '#e31837',
    fontFamily: 'Saira',
    fontWeight: 600,
    fontSize: '12px',
    marginTop: '10px'
  },
  btn1: {
    width: '100%',
    height: '48px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '600',
    color: 'white',
    borderRadius: '0px',
    padding: '15px'
  }
};

export default Feedback;
